export const PROGRAM_NAMES = {
  FLL: 'LEGO League Challenge',
  FLLC: 'LEGO League Challenge',
  JFLL: 'LEGO League Explore',
  FLLD: 'LEGO League Discover',
  FTC: 'Tech Challenge',
};
